export { default } from './ColorPickerCompact';
